import { SortDirection, SortType } from '@css-xp/ppc-graphtypes';

export enum BillingProfileTableKeys {
  NAME = 'billingProfileName',
}

export const defaultBillingProfileSortOptions: SortType = {
  sortFields: ['name', 'id'],
  sortFieldsDirections: [SortDirection.ASC, SortDirection.DESC],
};

export const ELIGIBLE_BILLING_PROFILES_FOR_AMENDMENT = ['commercial'];
